import React, { useEffect, useState, Suspense } from "react";
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import css from "./topClientsMagneticStyle.less";
//components
import Spinner from "../../../common/Spinner";
import AppHOC from "../../../generics/AppHOC";
import { formatBarChartBytes } from "../../../utils/format";
//reducer files
import { connect } from "react-redux";
import { bindActionCreators } from "@reduxjs/toolkit";
import * as actions from "../../applications/actions";
import PropTypes from "prop-types";
import { useI18n } from "../../../i18n/useI18n";

const NoDataAvailable = React.lazy(
  () => import("../../../common/NoDataAvailable"),
);

const ErrorComponent = React.lazy(
  () => import("../../../common/ErrorComponent"),
);

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
});

const [HbrBarChart, HbrCard] = reactWrapper(["hbr-bar-chart", "hbr-card"]);

const TopClientsReportBarChart = (props) => {
  const { tViews } = useI18n();
  const [barChartData, setBarChartData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    setIsLoading(true);
    if (props?.data) {
      let usageData = [];
      const formattedData = props?.data.map((item) => {
        usageData.push(item.usage);
        return {
          source_ip: item.source_ip,
          Value: item.usage,
        };
      });
      setBarChartData({ data: formattedData });
      props.isTop10BarChartCallback?.(true);
    }
    setIsLoading(false);
  }, [props?.data]);

  // Show loading spinner while data is being fetched
  if (isLoading || props.tableLoader) {
    return (
      <div className="home-spinner-25">
        <Spinner />
      </div>
    );
  }

  // Show error message if API call failed
  if (props.error) {
    return (
      <Suspense fallback={<Spinner />}>
        <HbrCard
          id="non-interactive"
          slot="label"
          className="reports-top-clients-widget-hbr-card"
        >
          <div className={css["top-clients-usage-bar-chart"]}>
            <ErrorComponent
              {...props.error}
              width={"110px"}
              className={"super-small-dashlet-error"}
            />
          </div>
        </HbrCard>
      </Suspense>
    );
  }

  // Show message when no data is available
  if (!props.error && !isLoading && barChartData?.data?.length === 0) {
    return (
      <Suspense fallback={<Spinner />}>
        <HbrCard
          id="non-interactive"
          slot="label"
          className="reports-top-clients-widget-hbr-card"
        >
          <div className={css["top-clients-usage-bar-chart"]}>
            <NoDataAvailable text={tViews("applicationDashboardNoData")} />
          </div>
        </HbrCard>
      </Suspense>
    );
  }
  let config = {
    layout: "vertical",
    keys: ["Value", "No Data"],
    data: barChartData?.data,
    labelSkipWidth: 0,
    barItemTopLabel: (d) => `${formatBarChartBytes(d.value)}`,
    indexBy: "source_ip",
    axisLeft: {
      legendOffset: -28,
      legend: tViews("predictiveNetworks.applicationUsageInBytes"),
      tickPadding: -30,
      legendPosition: "middle",
      format: (d) => `${formatBarChartBytes(d)}`,
    },

    axisBottom: {
      legend: tViews("clientsIP"),
      tickPadding: 10,
      legendPosition: "middle",
      legendOffset: 40,
    },
    legends: [],
  };

  const onUpdate = (config) => {
    return config;
  };

  return (
    <HbrCard
      id="non-interactive"
      slot="label"
      className="reports-top-clients-widget-hbr-card"
    >
      <div className={css["top-clients-usage-bar-chart"]}>
        <HbrBarChart config={config} modifyHbrConfig={onUpdate} />
      </div>
    </HbrCard>
  );
};

TopClientsReportBarChart.propTypes = {
  actions: PropTypes.object,
  data: PropTypes.array.isRequired,
  error: PropTypes.string,
  isTop10BarChartCallback: PropTypes.func,
  tableLoader: PropTypes.bool,
};

export default connect(mapDispatchToProps)(AppHOC(TopClientsReportBarChart));
